import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '../firebase';

// Use Cloud Function for enrichment (OpenAI is called server-side to avoid CORS and keep API key secure)
const functions = getFunctions(app, 'us-central1');
const enrichVerseCallable = httpsCallable(functions, 'enrichVerse');

// Enrich a single verse by ID (calls Cloud Function; no browser → OpenAI)
export async function enrichSingleVerse(verseId, onStatusUpdate) {
  try {
    console.log(`[enrichSingleVerse] Starting enrichment for verseId:`, verseId);
    if (onStatusUpdate) onStatusUpdate({ status: 'loading', message: 'Fetching verse...' });
    const verseDoc = await getDoc(doc(db, 'verses', verseId));
    if (!verseDoc.exists()) {
      console.error(`[enrichSingleVerse] Verse not found for id:`, verseId);
      throw new Error('Verse not found');
    }
    const verse = { id: verseId, ...verseDoc.data() };
    if (!verse.reference || !verse.text) {
      throw new Error('Verse must have reference and text');
    }
    console.log(`[enrichSingleVerse] Calling enrichVerse Cloud Function for:`, verse.reference);
    if (onStatusUpdate) onStatusUpdate({ status: 'enriching', message: 'Enriching verse...' });
    const result = await enrichVerseCallable({
      verseId,
      verse: { reference: verse.reference, text: verse.text }
    });
    const data = result.data;
    if (!data?.success) {
      throw new Error(data?.message || 'Enrichment failed');
    }
    console.log(`[enrichSingleVerse] Enrichment success for verse ${verseId}`);
    if (onStatusUpdate) onStatusUpdate({ status: 'success', message: 'Verse enriched and updated!' });
    return true;
  } catch (err) {
    console.error(`[enrichSingleVerse] Error enriching verse ${verseId}:`, err);
    const message = err?.message || (err?.code === 'functions/permission-denied' ? 'Admin access required' : 'Enrichment failed');
    if (onStatusUpdate) onStatusUpdate({ status: 'error', message });
    return false;
  }
}

// Enrich multiple verses by VER IDs
export async function enrichVersesByIds(verseIds, onStatusUpdate) {
  let updated = 0;
  let failed = 0;
  console.log(`[enrichVersesByIds] Starting batch enrichment for verseIds:`, verseIds);
  for (let i = 0; i < verseIds.length; i++) {
    const verseId = verseIds[i];
    if (onStatusUpdate) onStatusUpdate({
      status: 'enriching',
      message: `Enriching verse ${i + 1} of ${verseIds.length}...`,
      progress: Math.round(((i + 1) / verseIds.length) * 100)
    });
    const success = await enrichSingleVerse(verseId);
    if (success) updated++;
    else failed++;
  }
  console.log(`[enrichVersesByIds] Batch enrichment complete. Updated: ${updated}, Failed: ${failed}`);
  if (onStatusUpdate) onStatusUpdate({
    status: 'done',
    message: `Enriched ${updated} verses. ${failed > 0 ? failed + ' failed.' : ''}`
  });
  return { updated, failed };
} 